// removed by extract-text-webpack-plugin
module.exports = {"ctrlButtons":"_1exS_DwiogWnI9Ero0D_sv","icon":"_1POd0FqfSBE4pQ-lvwlAfh","ctrlZoomOut":"PZ5YNoTY7tuhSI_QvDzx7","ctrlZoomIn":"_1HBjvp_X_OWZ7spGo7Zcsf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapControlButtons/MapControlButtons.scss
// module id = 1610
// module chunks = 0